<template>
    <div>
        <breadcrumb :routerList="[{to:'/personal/angentDetail',title:'个人中心'},{title:'基本信息编辑'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="containImgBox">
                            <div >
                                <div class="titles">账户信息</div>
                                <div>
                                    <div class="h-formLine">
                                        <el-form :model="supplier.bscUserInfoSupplierCopy" label-position="right" ref="supplier3" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <div class="h-rowCon">
                                                <div class="h-pieceIn2">
                                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                        <h1>基本信息</h1>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine">
                                                            <el-form-item label="供应商名称" class="h-elformWrap-2" prop="userName">
                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.userName"  readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="街道/房号" class="h-elformWrap-2" prop="inStreetRoom">
                                                                <el-input placeholder="请输入" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.inStreetRoom" readonly></el-input>
                                                            </el-form-item>
<!--                                                            <el-form-item label="邮政编码" class="h-elformWrap-2" prop="inPostalCodeCity">-->
<!--                                                                <el-input placeholder="请输入" -->
<!--                                                                    v-model="supplier.bscUserInfoSupplierCopy.inPostalCodeCity" readonly></el-input>-->
<!--                                                            </el-form-item>-->
<!--                                                            <el-form-item label="供应商账户组" class="h-elformWrap-2" prop="InAccountGrpCode">-->
<!--                                                                <el-input placeholder="请输入" -->
<!--                                                                    v-model="supplier.bscUserInfoSupplierCopy.InAccountGrpCode" readonly></el-input>-->
<!--                                                            </el-form-item>-->
                                                            <el-form-item label="对应公司代码" class="h-elformWrap-2" prop="subCompany">
                                                                <el-input placeholder="请输入" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.subCompany" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="电话" class="h-elformWrap-2" prop="inPhoneNumber">
                                                                <el-input placeholder="请输入" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.inPhoneNumber" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="国家" class="h-elformWrap-2" prop="inCountry">
                                                                <brselectlazy category="YLCountry_agent" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.inCountry" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.inCountry" :clearable="true" disabled/>
                                                            </el-form-item>
                                                            <el-form-item label="地区" class="h-elformWrap-2" prop="inRegion" v-if="this.supplier.bscUserInfoSupplierCopy.inCountry == 'CN'">
                                                                <brselectlazy category="YLRegion" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.inRegion" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.inRegion" :clearable="true" disabled/>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="h-pieceIn2">
                                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                        <h1>公司信息</h1>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine">
                                                            <el-form-item label="公司代码" class="h-elformWrap-2" prop="companyCode">
                                                                <brselectlazy category="YlCompanyCode_agent" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.companyCode" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.companyCode" 
                                                                    :clearable="true" disabled />
                                                            </el-form-item>
<!--                                                            <el-form-item label="统驭科目" class="h-elformWrap-2" prop="reconcileAccount">-->
<!--                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.reconcileAccount"></el-input>-->
<!--                                                            </el-form-item>-->
<!--                                                            <el-form-item label="付款条件" class="h-elformWrap-2" prop="paymentTerm">-->
<!--                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.paymentTerm"></el-input>-->
<!--                                                            </el-form-item>-->
<!--                                                            <el-form-item label="付款方式" class="h-elformWrap-2" prop="paymentMethod">-->
<!--                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.paymentMethod" ></el-input>-->
<!--                                                            </el-form-item>-->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="h-pieceIn2">
                                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                        <h1>银行信息</h1>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine">
                                                            <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                                                                <brselectlazy category="YLCountry_agent" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.bankCountry" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.bankCountry" 
                                                                    :clearable="true" disabled/>
                                                            </el-form-item>
                                                            <el-form-item label="银行码" class="h-elformWrap-2"  prop="bankBranchCode">
                                                                <brselectlazy category="BankCategory_agent" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.bankBranchCode" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.bankBranchCode" 
                                                                    :clearable="true" disabled />
                                                            </el-form-item>
                                                            <el-form-item label="银行户主" class="h-elformWrap-2" prop="bankAccountNum">
                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.bankAccountNum" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="银行账户" class="h-elformWrap-2"  prop="accountHolderName">
                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.accountHolderName" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="订单货币" class="h-elformWrap-2"  prop="orderCurrency">
                                                                <brselectlazy category="YLCurrency" 
                                                                    :v="supplier.bscUserInfoSupplierCopy.orderCurrency" 
                                                                    v-model="supplier.bscUserInfoSupplierCopy.orderCurrency" 
                                                                    :clearable="true" disabled />
                                                            </el-form-item>
                                                            <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseGrpCode" >
                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.purchaseGrpCode" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="PI合作伙伴" class="h-elformWrap-2"  prop="partnerPi">
                                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.partnerPi" readonly></el-input>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="h-pieceIn2">
                                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                        <h1>资质信息</h1>
                                                    </div>
                                                    <div class="upload">
                                                        <el-form-item label="查看营业执照凭证" class="h-elformWrap-1" prop="upload">
                                                            <brupload
                                                                    v-if="isShow"
                                                                    :refid = "refid"
                                                                    reftype = "供应商注册-营业执照信息"
                                                            >
                                                            </brupload>
                                                        </el-form-item>
                                                    </div>
                                                    <div class="upload">
                                                        <el-form-item label="查看二级资质凭证" class="h-elformWrap-1" prop="upload">
                                                            <brupload
                                                                    v-if="isShow"
                                                                    :refid = "refid"
                                                                    reftype = "供应商注册-二级资质信息"
                                                            >
                                                            </brupload>
                                                        </el-form-item>
                                                    </div>
                                                    <div class="upload">
                                                        <el-form-item label="查看三级资质凭证" class="h-elformWrap-1" prop="upload">
                                                            <brupload
                                                                    v-if="isShow"
                                                                    :refid = "refid"
                                                                    reftype = "供应商注册-二级资质信息"
                                                            >
                                                            </brupload>
                                                        </el-form-item>
                                                    </div>
                                                        </div>
                                                    </div>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                    <div class="bannerBox2">
                        <div class="h-row h-mrt1">
                            <div class="h-rowIn">
                                <div class="h-rowBox">
                                    <div class="h-rowCon">
                                        <div class="h-pieceIn2">
                                            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                <h1>审核信息</h1>
                                            </div>
                                            <div class="h-pieceCon2 ">
                                                <div class="h-formLine weekplandetail" style="position: relative;">
                                                    <el-form :inline="true" :model="supplier.bscUserInfoSupplierCopy">
                                                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                                      style="width: 100%!important;">
                                                            <el-input
                                                                    v-model="supplier.bscUserInfoSupplierCopy.yjmsg"
                                                                    placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                    </el-form>
                                                    <viewhistory :visible.sync="showhistory" v-if="showhistory"
                                                                 :id="instid"/>
<!--                                                    <el-button class="passfollow" @click="viewpress">-->
<!--                                                        <img src="../../assets/images/followicon.png"-->
<!--                                                             style="margin-bottom: -0.03rem;">-->
<!--                                                        审批跟踪-->
<!--                                                    </el-button>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <div class="h-txtCenter h-mrt60">
            <el-button class="h-btn h-bBtn" :class="{'h-bgwhite':this.flag!=='2'}" @click="goBack">返回</el-button>
            <el-button class="h-btn h-bBtn h-bgred" @click="update('2')" v-show="this.$route.query.taskstatus != 1">驳回</el-button>
            <el-button class="h-btn h-bBtn h-bggreen" @click="update('1')" v-show="this.$route.query.taskstatus != 1">通过</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </div>
    </div>
    </div>
</template>

<script>
    import supplierVerityService from "../../api/personal/supplierVerityService";
    export default {
        data(){
            return{
                instid: null,
                showhistory: false,
                refid: null,
                have: false,
                supplier: {
                    bscUserInfo: {
                        usercode: null,//员工编码/公司编码
                        password: '',//密码
                        usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
                        username: null,//公司名称/员工姓名username
                        companycode: null,//公司名称/员工姓名username
                        email: null,//邮箱
                        phone: null,//联系人电话
                        deptcode: null,//所属部门编码deptcode  公司用户为空
                        userdept: null,//用户详细部门userdept  公司用户为空
                        deptname: null,//部门名称deptname  公司用户为空
                        firstline: null,//一线经理firstline  公司用户为空
                        secondline: null,//二线经理secondline  公司用户为空
                        status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
                        organization: null,//公司地址/住址机构
                        cdate: null,//创建时间
                        ldate: null,//更新时间
                        logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
                        lastlogintime: null,//最后登录时间: 记录最后登录时间
                        accountdate: null,//账户有效期
                        area: null,//负责区域
                        lucode: null,//更新人编码
                        countrytype: null,//1- 国内  /  2- 国外   账户
                        fileId: null,//1- 国内  /  2- 国外   账户
                    },
                    bscUserInfoSupplierCopy: {
                        usercode: null,//公司编号
                        userName: '',//公司名称
                        inLanguage: null,// 语言 ,   , 扩充不用填 ,   ,
                        inStreetRoom: null,// 街道/房号 ,   , 扩充不用填 ,   ,
                        inPostalCodeCity: null,// 邮政编码 ,   , 扩充不用填 ,   ,
                        inCountry: null,// 国家 , 条件: 选择框(Country) , 扩充不用填 ,   ,
                        inRegion: null,// 地区 , 条件: 选择框(Region) , 扩充不用填 ,   ,
                        inPhoneNumber: null,// 电话 ,   , 扩充不用填 ,   ,
                        subCompany: null,// 对应公司代码 ,   , 扩充不用填（集团内法人公司供应商必填,填写该公司的4位公司代码） ,   ,
                        reconcileAccount: null,// 统驭科目 , 条件: 选择框(ReconcileAccount) 扩充 必填 通过供应商账户组和统御科目对照过程确定 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        sequenceNo: null,// 排序码 , 条件: 选择框(OrderCode) 扩充 必填 默认 001 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        paymentTerm: null,// 付款条件 , 条件: 选择框(PayTerm) 扩充 必填 默认 0000 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        paymentMethod: null,// 付款方式 , 条件: 选择框(PayMethod) 扩充 必填 默认 I ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        accountHolderName: null,// 银行账户 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankCountry: null,// 银行所属国家 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankAccountNum: null,// 银行户主 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankBranchCode: null,// 银行码 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        purchaseGrpCode: null,// 采购组织 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        orderCurrency: null,// 订单货币 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        partnerPi: null,// PI合作伙伴 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        systemName: null,// 系统名称 , 条件: 扩充 必填 填写 ALM系统编号 , 可根据需要修改 ,   , 字段归属: 通用字段
                        viewBank: null,// 是否更新银行 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewBase: null,// 是否更新基本信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewComp: null,// 是否更新公司信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewPur: null,// 是否更新采购信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        operateType: null,// 操作状态 , 条件: 扩充填写 EXTEND , 操作状态 ,   , 字段归属: 通用字段
                        createdBy: null,// 创建人 , 条件: 非必填 建议填写流程的发起人 , 创建人 ,   ,
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用,0：删除标志
                        upload1: null,
                        upload2: null,
                        upload3: null,
                    },
                },
                query: {},
                isShow: false,
            }
        },
        created() {
            this.query = this.$route.query;
            this.instid = this.$route.query.instid;
            console.log(this.query,'跳转携带的参数')
            this.querySupplierData();
        },
        methods:{
            viewpress() {
                this.showhistory = true;
            },
            update(v){
                this.supplier.bscUserInfoSupplierCopy.taskid = this.query.taskid;
                this.supplier.bscUserInfoSupplierCopy.isPassed = v;
                supplierVerityService.approveCreate(this.supplier).then(response => {
                    if (response.f){
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        })
                    }
                });
             },
            goBack(){
                var defaultpage = this._user.defaultpage;
                this.$router.push({path: defaultpage});
            },
            querySupplierData(){
                supplierVerityService.querySupplierData(this.query.instid).then(response => {
                    console.log(response,'查询到的供应商信息')
                    this.supplier.bscUserInfoSupplierCopy = response.obj;
                    this.supplier.bscUserInfo.companycode = response.obj.companyIdCode;
                    this.refid = response.obj.userName;
                    this.isShow = true;
                })
            },
        }
    }
</script>

<style>
    .h-formbLine .el-form-item__label{
        width: 31%;
        text-align: right;
    }
    .h-formbLine .el-form-item__content{
        width: 69%;
    }
    .h-formbLine .h-elformWrap-2{
        width: 33.333%!important;
        padding-right: 0.5rem
    }
 
</style>
